export default __webpack_public_path__ + "static/media/C.ac84948d.png";